import { Component, Input, input, output } from '@angular/core';

@Component({
	selector: 'dialogs-helpbox-layout',
	templateUrl: './dialogs-helpbox-layout.component.html',
	styleUrls: ['./dialogs-helpbox-layout.component.scss'],
	standalone: false,
})
export class DialogsHelpboxLayoutComponent {
	readonly content = input<string>('');
	@Input() helpOpen!: boolean;
	readonly helpOpenChange = output<boolean>();

	public toggleHelp() {
		this.helpOpen = !this.helpOpen;
		this.helpOpenChange.emit(this.helpOpen);
	}
}
